import { Route, BrowserRouter, useNavigate as Router, Routes, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { NotificationProvider } from './utils/notifications';

import Session from './utils/session';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Login from './pages/Login/Login';
import Academy from './pages/Academy/Academy';
import Chapter from './pages/Academy/Chapter/Chapter';
import DashboardView from './pages/Dashboard/Dashboard';
import Error from './components/Error/Error';
import Score from './pages/Score/Score';
import Onboarding from './pages/Onboarding/Onboarding';
import Activity from './pages/Activity/Activity';
import FalseEmails from './pages/FalseEmails/FalseEmails';
import Email from './pages/FalseEmails/Email/Email';
import PasswordReset from './pages/PasswordReset/PasswordReset';

import { 
  urlHome, urlLogin,
  urlScore, urlAcademy, 
  urlAll, urlActivity, 
  urlOnboard,
  getToken, systemLanguage,
  languages, enUS,
  getLanguage, setLanguage, authToken, 
  signOutService, menuOpen, getMenuOpened,
  checkRequiredParams,
  urlFalseEmails,
  urlPasswordReset
} from './utils/constants';


function App() {

  const navigate = useNavigate()

  const [token, setToken] = useState<string>(getToken());
  const [menuOpened, setMenuOpenedIs] = useState<string>(getMenuOpened());

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!token);
  const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false)

  const [sessionLang,setSessionLang] = useState<string>(getLanguage());

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === authToken) {
        const newToken = event.newValue;
        setToken(newToken || '');
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (token) {
      setIsAuthenticated(true); 
    } else {
      setIsAuthenticated(false); 
    }
  }, [token]);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === menuOpen) {
        const newMenuOpenStatus = event.newValue;
        setMenuOpenedIs(newMenuOpenStatus || 'false');
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (menuOpened === 'true') {
      setIsMenuOpened(true); 
    } else {
      setIsMenuOpened(false); 
    }
  }, [menuOpened]);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === systemLanguage) {
        const newLanguage = event.newValue;
        setLanguage(newLanguage || '');
        setSessionLang(newLanguage || '')
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (!sessionLang || sessionLang === "") {
      const defaultLang = languages(enUS);
      setLanguage(JSON.stringify(defaultLang))
    }
  }, [sessionLang]);
  
  const handleGoHome = () => {
    navigate(urlHome);
  }

  const handleSignOut = async () => {
    setIsAuthenticated(false)
    signOutService()
    handleGoHome()
  };

  const requirements = checkRequiredParams()
  if(!requirements && isAuthenticated){
    handleSignOut()
  }

  const isOnboardingPath = (url = window.location.pathname) => {
    const [firstSegment] = url.replace(/^\/+|\/+$/g, "").split("/");
    return '/' + firstSegment === urlOnboard;
  }

  const isPasswordResetPath = (url = window.location.pathname) => {
    const [firstSegment] = url.replace(/^\/+|\/+$/g, "").split("/");
    return '/' + firstSegment === urlPasswordReset;
  }
  
  return (
    <>
      <Session activeToken={token} unAuthenticate={handleSignOut} isOnboarding={isOnboardingPath()} isPasswordReset={isPasswordResetPath()} />
      <NotificationProvider>
      {
        isAuthenticated ?
          <Header isAuthenticated={isAuthenticated} handleSignOut={handleSignOut} language={sessionLang} /> : ''
      }
      <div className="App">
        <div className={`${isAuthenticated && isMenuOpened ? "view-container" : "view-container full"}`}>
          <Routes>
            <Route path={urlHome} element={<DashboardView />} />
            <Route path={urlOnboard + '/:user_language/:otp_key'} element={<Onboarding language={sessionLang} />} />
            <Route path={urlPasswordReset + '/:user_language/:otp_key'} element={<PasswordReset language={sessionLang} />} />
            <Route path={urlLogin} element={<Login />} />
            <Route path={urlScore} element={<Score />} />
            <Route path={urlAcademy} element={<Academy />} />
            <Route path={urlFalseEmails} element={<FalseEmails />} />
            <Route path={urlFalseEmails+'/:page_number'} element={<FalseEmails />} />
            <Route path={urlFalseEmails+'/article/:article_uuid'} element={<Email />} />
            <Route path={urlAcademy+'/:chapter'} element={<Chapter isMenuOpened={isMenuOpened} language={sessionLang} />} />
            <Route path={urlAcademy+'/:chapter/:module/:sub'} element={<Chapter isMenuOpened={isMenuOpened} language={sessionLang} />} />
            <Route path={urlActivity} element={<Activity />} />
            <Route path={urlAll} element={<Error />} />
          </Routes>
        </div>
      </div>
      <Footer />
      </NotificationProvider>
    </>

  );
}

export default App;
